export default __webpack_public_path__ + "static/media/toast-close.cc3bb9a0.svg";